import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useState } from "react";
import {
  Route,
  RouteComponentProps,
  Switch,
  withRouter,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Loader from "../components/common/Loader";
import PrivateRoute from "../components/common/PrivateRoute";
import AuthLayout from "../layouts/AuthLayout";
import ExpiredLayout from "../layouts/ExpiredLayout";
import TenantSelectionLayout from "../layouts/TenantSelectionLayout";
import { RootStoreContext } from "./stores/rootStore";
import { disableBodyScroll } from "body-scroll-lock";
import OfflineAuthLayout from "../layouts/OfflineAuthLayout";
import { useSQLite } from "react-sqlite-hook/dist";
import { IExistingSqliteConn, ISqlite } from "./models/db";
import OfflineTenantSelectionLayout from "../layouts/OfflineTenantSelectionLayout";
import OfflineDashboardLayout from "../layouts/OfflineDashboardLayout";
import LogoutLayout from "../layouts/LogoutLayout";
import "./localization/localization";
import TenantLayout from "../layouts/TenantLayout";
import GuestLayout from "../layouts/GuestLayout";
import {ResponsiveComponent} from "../components/common/ResponsiveComponent"
import MicrophoneSelectionLayout from "../layouts/MicrophoneSelectionLayout";
import ScreenCodePage from "../components/guest/ScreenCodePage";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "./localization/localization";
export let sqlite: ISqlite;
export let existingConn: IExistingSqliteConn;

const PlayerApp: React.FC<RouteComponentProps> = ({ location }) => {


  const rootStore = useContext(RootStoreContext);

  const {
    getCompany,
    setCompanyLoaded,
    setAppLoaded,
    // token,
    InitNativeApp,
    updateOfflineModeEnabled,
    isOfflineModeEnabled,
    nativeAppLoaded,
    setNativeAppLoaded,
    everythingLoaded,
  } = rootStore.commonStore;
  const { getUser, isLoggedIn } = rootStore.userStore;
 
  const [existConn, setExistConn] = useState(false);
  existingConn = { existConn: existConn, setExistConn: setExistConn };
  const {
    echo,
    getPlatform,
    isConnection,
    checkConnectionsConsistency,
    isDatabase,
    createConnection,
    closeConnection,
    retrieveConnection,
    retrieveAllConnections,
    closeAllConnections,
    addUpgradeStatement,
    importFromJson,
    isJsonValid,
    copyFromAssets,
    isAvailable,
  } = useSQLite({});
  sqlite = {
    echo: echo,
    getPlatform: getPlatform,
    isConnection: isConnection,
    checkConnectionsConsistency: checkConnectionsConsistency,
    isDatabase: isDatabase,
    createConnection: createConnection,
    closeConnection: closeConnection,
    retrieveConnection: retrieveConnection,
    retrieveAllConnections: retrieveAllConnections,
    closeAllConnections: closeAllConnections,
    addUpgradeStatement: addUpgradeStatement,
    importFromJson: importFromJson,
    isJsonValid: isJsonValid,
    copyFromAssets: copyFromAssets,
    isAvailable: isAvailable,
  };

  useEffect(() => {
    InitNativeApp()
      .then(() => {
        updateOfflineModeEnabled(!navigator.onLine);
        disableBodyScroll(document.body);
      })
      .catch((e) => console.log(e))
      .finally(() => setNativeAppLoaded());
  }, [InitNativeApp, updateOfflineModeEnabled, setNativeAppLoaded]);

  useEffect(() => {
    if (nativeAppLoaded) {
      const urlParams = new URLSearchParams(location.search);
      const companyIdApp = process.env.REACT_APP_FORCE_COMPANYID ?? "";
      const companyIdQuerystring = urlParams.get("companyId") ?? "";
      const companyId = companyIdQuerystring
        ? companyIdQuerystring
        : companyIdApp;
      getCompany(companyId)
        .then()
        .finally(() => setCompanyLoaded());
    }
  }, [getCompany, location.search, setCompanyLoaded, nativeAppLoaded]);

  //tolto token dal array delle dipendenze per evitare chiamate multiple
  useEffect(() => {
    // console.log("LoggedIn : " + isLoggedIn)
    if (!isLoggedIn && !isOfflineModeEnabled) {
      getUser()
        .then()
        .finally(() => setAppLoaded());
    } else {
      setAppLoaded();
      
    }
  }, [getUser, setAppLoaded, isOfflineModeEnabled, isLoggedIn]);

  
  
  if (!everythingLoaded) return <Loader />;

  return (
    <>
    <ResponsiveComponent/>
      <ToastContainer
        position="bottom-right"
        pauseOnFocusLoss={false}
        limit={4}
        />
      <Route exact path="//Microphone" component={MicrophoneSelectionLayout} />

      <Route exact path="/" component={AuthLayout}  />
      {isOfflineModeEnabled ? (
        <Switch>
          <Route exact path="/offline" component={OfflineAuthLayout} />
          <Route exact path="/offline/:tenant" component={OfflineAuthLayout} />
          <Route exact path="/home" component={OfflineTenantSelectionLayout} />
          <Route path="/:tenant" component={OfflineDashboardLayout} />
        </Switch>
      ) : (
        <Switch>
          <Route exact path="/offline" component={OfflineAuthLayout} />
          <Route exact path="/offline/:tenant" component={OfflineAuthLayout} />
          <PrivateRoute exact path="/home" component={TenantSelectionLayout} />
          <Route exact path="/expired" component={ExpiredLayout} />
          <Route exact path="/expired/:isInactive" component={ExpiredLayout} />
          <Route exact path="/logout" component={LogoutLayout} />
          {/*<Route exact path="/guest" component={GuestLayout} />
          <Route exact path="/guestscreen" component={ScreenCodePage} />
           <Route exact path="/guest/:zone" component={GuestLayout} /> */}
          <Route exact path="/:tenant" component={AuthLayout} />
          <PrivateRoute path="/:tenant" component={TenantLayout} />
        </Switch>
      )}
    </>
  );
};

export default withRouter(observer(PlayerApp));
